import React, {Fragment, useState} from 'react';
import ForCard from 'containers/about-us/ForCard';
import Responsible from 'evcharging/components/Responsible';
import Container from 'evcharging/components/Container';
import Section from 'evcharging/containers/layout/Section';
import forHome from 'assets/about-us/forHome.png';
import forBusiness from 'assets/about-us/forBusiness.png';
import Solutions from 'containers/about-us/Solutions';
import Spacer from 'evcharging/components/Spacer';
import useI18n from 'evcharging/hooks/useI18n';
import Desktop from 'evcharging/components/Desktop';
import Mobile from 'evcharging/components/Mobile';

const ForItems = () => {
  const [expandIndex, setExpandIndex] = useState<number>(0);
  const { t } = useI18n();

  const onToggle = (index: number) => () => {
    setExpandIndex(index === expandIndex ? null : index);
  };

  const items = [
    // {
    //   image: forHome,
    //   title: t('about-us.for-every'),
    //   text: <>
    //     {t('about-us.crafting-energy')}
    //     <br />
    //     {t('about-us.discover-a')}
    //   </>
    // },
    {
      image: forBusiness,
      title: t('about-us.for-all'),
      text: <>
        {t('about-us.redefining-business')} {' '}
        {t('about-us.unlock-value')}
      </>
    }
  ];

  return (
    <Section background={'light'}>
      <Container>
        <Responsible justifyContent={'center'} fractions={[63, 40]}>
          {items.map((item, index) => (
            <Fragment key={index}>
              <ForCard
                {...item}
                expand={true}
                // onToggle={onToggle(index)}
              />
              <Mobile>
                {expandIndex !== null && <Solutions index={index} />}
              </Mobile>
            </Fragment>
          ))}
          <Desktop>
            {expandIndex !== null && (
              <Solutions index={expandIndex} />
            )}
          </Desktop>
        </Responsible>
        <Spacer value={64} mobile={12} />

      </Container>
    </Section>
  );
};

export default ForItems;
